import React, { useState } from 'react';
import axios from 'axios';
import { ProgressBar, Button } from 'react-bootstrap';
import '../styles/FileUploader.css'
import { restart } from "./Board.js";
import { data } from './Board.js';
import * as tf from '@tensorflow/tfjs';

const fileSystem = require('fs');
export let model;

let backendUrl = process.env.REACT_APP_BACKEND_URL|| 'http://localhost:8800';

export default function FileUploader() {
  const [selectedFiles, setSelectedFiles] = useState(0);
  const [fileUrl, setFileUrl] = useState(null);

  const selectFiles = (event) => {
    setSelectedFiles(event.target.files);
  };

  // Load model no matter what

  


  const uploadDefaultModel = async () => {
    data.model_status='uploading';
    data.model_path = `${backendUrl}/model/default_model/model.json`;
  
    console.log(`data.model_path : ${data.model_path}`)
    await loadModel(data.model_path);
    data.model_status='uploaded';

    data.model_uploaded = true;
    setFileUrl(data.model_path);
    // console.log(`fileUrl : ${fileUrl}`)
  }

  const removeModel = async () => {
    console.log(`process.env.REACT_APP_BACKEND_URL: ${process.env.REACT_APP_BACKEND_URL}`)
    data.model_path = '';
    data.model_uploaded = false;
    setFileUrl(null);
    // restart(data.size);

    // Remove uploaded model from folder using get API get request
    await axios.get(`${backendUrl}/delete`)
      .then(response => {
        console.log(response.data);
      })
      .catch(error => {
        console.error(error);
      });

    unloadModel();
    data.model_status='no model';

  }

  const uploadModel = async () => {
    
    const formData = new FormData();

    for (let i = 0; i < selectedFiles.length; i++) {
      formData.append('file', selectedFiles[i]);
    }

    console.log("Posting...");


    await axios.post(`${backendUrl}/uploadmodel`, formData, {
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
        'Access-Control-Allow-Headers': 'Content-Type, Authorization'
      }
    }).then((response) => {
      // console.log("Setting file Url ...");
      // setFileUrl(response.data.fileUrl);
      // console.log(`response.data.fileUrl : ${response.data.fileUrl}`)
      
    });

    if (selectedFiles != 0) {
      data.model_status='uploading';
      data.model_path = `${backendUrl}/model/uploaded_model/model.json`; 
      data.model_uploaded = true;
      setFileUrl(data.model_path); 
      console.log(`data.model_path : ${data.model_path}`)
      // console.log(`fileUrl : ${fileUrl}`)
      // data.model_path = fileUrl;
      
      // Need to add delay because it was not able to retrieve the files that fast
      setTimeout(async () => {
        console.log('FINALLY LOADING MODEL');
        console.log('loading model now...')
        await loadModel(data.model_path);
        data.model_status='uploaded';
    }, 2000);
      
      
    }
  };

  async function loadModel(model_path) {
      console.log("Loading Model...");
      try{
        model = await tf.loadGraphModel(model_path);
        console.log("Model has been loaded...");
      } catch(err) {
        console.log(`Unable to load model : ${err}`);
      } 
  }

  function unloadModel() {
      model = '';
      console.log("Model has been unloaded...")
  }

  // Upload Model no matter what
  uploadDefaultModel();

  return (
    <div>
      
      {/* <div class="container-1">
        <text><b>Upload Tensorflow Model:</b> &nbsp;  &nbsp;</text>
        <input type="file" onChange={selectFiles} multiple />
        <Button className="upload-button" onClick={uploadModel}>Upload</Button>
        <Button className="default-button" onClick={uploadDefaultModel}>Use Default PRIMAL Model</Button>
        {data.model_uploaded &&
          <Button className="remove-button" onClick={removeModel}>Remove Model</Button>
        }
      </div> */}

    </div>


  );
}

